<template>
  <div
    :class="$style.emailBadge"
  >
    <span
      :class="$style.email"
      :title="email"
    >
      {{ email }}
    </span>
    <slot name="badgeAction" />
  </div>
</template>

<script>
export default {
  name: 'EmailBadge',

  props: {
    email: {
      type: String,
      required: true,
    },
  },
};
</script>

<style module>
@value (jcGrey800, jcGrey200) from 'css/brand-colors.css';

.emailBadge {
  border: 1px solid jcGrey200;
  border-radius: 1em;
  color: jcGrey800;
  display: inline-flex;
  font-size: 0.875rem;
  margin: 0 auto 1.5rem auto;
  max-width: 100%;
  padding: 0.375rem 1.5rem;
}

.email {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
